import type { IRoles } from "../resources-vue/vue-interfaces/i-roles";

export interface IAppAccessRoles {
    canUseAxxessCare: boolean;
}
export class AccessService {
    private _roles: IAppAccessRoles = {
        canUseAxxessCare: false
    };
    public areRolesLoaded: boolean = false;

    public initAccessRoles(roles: IRoles[]) {
        this.initRoles(roles);
        this.areRolesLoaded = true;
        return this._roles;
    }

    public initRoles(roles: IRoles[]) {
        if (roles?.length === 0) {
            return;
        }
        this._roles.canUseAxxessCare = roles.some((role) => role.canUseAxxessCare);
    }

    public getAccessRoles() {
        return this._roles;
    }
}
